var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project"},[_c('div',{staticClass:"list"},[_c('hight-light',{staticClass:"title",attrs:{"text":"我们的服务","bg-text":"Why our service","is-bg":true}}),_c('ProductList',{attrs:{"projects":_vm.projects,"img-height":"260px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }